import { ContentType, iMessageContent } from '../types/chat'

export const getContentByType = (content: iMessageContent) => {
  const { text, sticker } = content

  switch (content['@type']) {
    case ContentType.text:
      return text!.text
    case ContentType.sticker:
      return sticker!.emoji
    default:
      return `[${content['@type']}]`
  }
}
